import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { headingModule } from './heading';

gsap.registerPlugin(DrawSVGPlugin);

const introModule = () => {

    const introWrapper = document.querySelector('.js-intro');

    if (introWrapper) {

        const logoOutlineWrapper = introWrapper.querySelector('.js-logo-outline-wrapper');
        const logoOutline = introWrapper.querySelector('path');

        const logoSolidWrapper = introWrapper.querySelector('.js-logo-solid');

        gsap.set([logoOutline], {
            drawSVG: "0% 0%",
        });

        gsap.set([logoOutlineWrapper], {
            opacity: 1,
        });

        const tl = gsap.timeline();

        tl
        .to(logoOutline, {
            drawSVG: '-50% 70%',
            duration: 6,
            delay: 0.3,
        })
        .to(logoSolidWrapper, {
            opacity: 1,
            duration: 1.5,
            ease: 'power4.inOut',
            onComplete: headingModule
        }, 1.25)
        .to(introWrapper, {
            scale: 1.1,
            duration: 2,
            ease: 'power4.inOut',
        }, 1.25)
        .to(introWrapper, {
            opacity: 0,
            duration: 1.5,
            filter: 'blur(40px)',
        }, 3);

    } else {

        headingModule();

    }

}

export { introModule };